import { UpdateSlice } from '@Store/slices/update';

// eslint-disable-next-line import/prefer-default-export
export const { setUpdateState, setUpdateFilterState, clearFilterState } =
  UpdateSlice.actions;
